import { render, staticRenderFns } from "./KYCList.vue?vue&type=template&id=a51cd57e&scoped=true"
import script from "./KYCList.vue?vue&type=script&lang=js"
export * from "./KYCList.vue?vue&type=script&lang=js"
import style0 from "./KYCList.vue?vue&type=style&index=0&id=a51cd57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51cd57e",
  null
  
)

export default component.exports